import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import getEmailsBySourceDataId from "@app/services/cases/getEmailsBySourceDataId";

import { useToast } from "@hooks/useToast";

export const useEmailsTab = () => {
  const { messages } = useIntl();
  const { showErrorToast } = useToast();
  const { data_source_id } = useParams();

  const [emailsData, setEmailsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchEmailsForDataSource = async () => {
      try {
        setIsLoading(true);

        const { data = [] } = await getEmailsBySourceDataId(data_source_id);

        setEmailsData(data);
      } catch {
        showErrorToast(messages.exception_error_message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmailsForDataSource();
  }, [data_source_id, messages.exception_error_message, showErrorToast]);

  return {
    emailsData,
    isLoading,
  };
};
